<template>
  <div :id="slideId" :style="slideStyle" class="uk-margin uk-inline" :class="layoutImg(slideData.imgAlign)">
    <img :src="url(slideData.img)" :style="imgStyle"/>
    <div
      :class="layoutClass(slideData.textLayout)" class="uk-overlay uk-text-left"
      :style="layoutStyle(slideData.textLayout)">
      <div v-html="slideData.text"></div>
    </div>
    <div
      :class="layoutClass(slideData.caption)" class="uk-overlay uk-text-left" :style="layoutStyle(slideData.caption)">
      <div v-html="slideData.img.caption"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['size', 'index', 'slideData'],
  data () {
    return {
      slideId: this.slideData.id
    }
  },
  mounted () {

  },
  computed: {
    slideStyle () {
      return {
        height: '' + (this.size.h - 0) + 'px',
        width: '100%',
        backgroundColor: 'black'
      }
    },
    imgStyle () {
      return {
        maxHeight: '' + this.size.h + 'px',
        maxWidth: '100%'
      }
    },
    captionClass () {

    },
    captionStyle () {

    }
  },
  methods: {
    url (img) {
      return 'static/imgs/' + img.url
    },
    layoutImg (elem) {
      return {
        'uk-text-center': elem === undefined || elem === 'center',
        'uk-text-left': elem === 'left',
        'uk-text-right': elem === 'right'
      }
    },
    layoutClass (elem) {
      return {
        'uk-position-center-right': elem.pos === 'center-right',
        'uk-position-center-left': elem.pos === 'center-left',
        'uk-position-center': elem.pos === 'center',
        'uk-position-top-right': elem.pos === 'top-right',
        'uk-position-top-left': elem.pos === 'top-left',
        'uk-position-bottom-left': elem.pos === 'bottom-left',
        'uk-position-bottom-right': elem.pos === 'bottom-right',
        'pad-bottom': elem.pos === 'bottom-left' || elem.pos === 'bottom-right',
        'pad-top': elem.pos === 'top-left',
        'uk-overlay-primary': elem.bg === true
      }
    },
    layoutStyle (elem) {
      return {
        'maxWidth': elem.w + '%'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pad-top {
  margin-top: 80px;
}

.pad-bottom {
  margin-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/Slide.vue